export const DefaultMoodIconSize = 22
export const DefaultCountryCode = "1"
export const DefaultCountry = "US"

const minutesToLogout = 15
const MILLISECONDS_IN_SECONDS = 1000
const SECONDS_IN_MINUTES = 60
export const idleTimeoutTime =
  minutesToLogout * MILLISECONDS_IN_SECONDS * SECONDS_IN_MINUTES

export enum NudgeDomain {
  MOTIVATIONAL_INTERVIEWING = "Motivational Interviewing",
  BEHAVIORAL_ACTIVATION = "Behavioral Activation",
  COGNITIVE_RESTRUCTURING = "Cognitive Restructuring",
  MINDFULNESS_AND_RELAXATION = "Mindfulness and Relaxation",
  EXPOSURE_THERAPY = "Exposure Therapy",
  SLEEP_IMPROVEMENT = "Sleep improvement",
  ASSERTIVENESS_TRAINING = "Assertiveness Training",
  RELAPSE_PREVENTION = "Relapse Prevention",
  PRACTITIONER_DEFINED = "Practitioner Defined",
  EMOTIONAL_COOLDOWN = "Emotional Cooldown",
  DBT_MINDFULNESS = "DBT Mindfulness",
  DBT_DISTRESS_TOLERANCE = "DBT Distress Tolerance",
  DBT_EMOTION_REGULATION = "DBT Emotion Regulation",
  DBT_INTERPERSONAL_EFFECTIVENESS = "DBT Interpersonal Effectiveness",
  DBT_WALKING_THE_MIDDLE_PATH = "DBT Walking the Middle Path",
  KEEP_ME_CALM = "Keep Me Calm",
  KEEP_ME_SAFE = "Keep Me Safe",
}

export const nudgeOrder: NudgeDomain[] = [
  NudgeDomain.PRACTITIONER_DEFINED,
  NudgeDomain.DBT_MINDFULNESS,
  NudgeDomain.DBT_DISTRESS_TOLERANCE,
  NudgeDomain.DBT_EMOTION_REGULATION,
  NudgeDomain.DBT_INTERPERSONAL_EFFECTIVENESS,
  NudgeDomain.DBT_WALKING_THE_MIDDLE_PATH,
  NudgeDomain.MOTIVATIONAL_INTERVIEWING,
  NudgeDomain.BEHAVIORAL_ACTIVATION,
  NudgeDomain.COGNITIVE_RESTRUCTURING,
  NudgeDomain.MINDFULNESS_AND_RELAXATION,
  NudgeDomain.EXPOSURE_THERAPY,
  NudgeDomain.SLEEP_IMPROVEMENT,
  NudgeDomain.ASSERTIVENESS_TRAINING,
  NudgeDomain.RELAPSE_PREVENTION,
  NudgeDomain.EMOTIONAL_COOLDOWN,
  NudgeDomain.KEEP_ME_CALM,
  NudgeDomain.KEEP_ME_SAFE,
]

export enum QuestionnaireType {
  ANXIETY = "Anxiety (GAD-7)",
  DEPRESSION = "Depression (PHQ-8)",
  SUBSTANCE_USE = "Substance Use (PROMIS-8)",
}

export enum Role {
  USER = "user",
  ADMIN = "admin",
  PRACTITIONER = "practitioner",
  WEB_ROLE = "web_role",
}

export enum Severity {
  NO_DATA = 0,
  LOW = 1,
  MODERATE = 2,
  HIGH = 3,
}

export const Pending = "Pending"
export const Declined = "Declined"
export const Disconnected = "Disconnected"
export const PractitionerDisconnected = "Practitioner Disconnected"
export const ClientDisconnected = "Client Disconnected"
export const AccountDeleted = "Account Deleted"

export const ComponentHeaderHeight = 92

export enum InviteCodeStatus {
  CONNECTED = "connected",
  PENDING = "pending",
  DECLINED = "declined",
  PRACTITIONER_DISCONNECTED = "practitioner disconnected",
  CLIENT_DISCONNECTED = "client disconnected",
  ACCOUNT_DELETED = "account deleted",
}

export enum Query {
  GET_ORGANIZATION = "GetOrganization",
  GET_PRACTITIONER = "GetPractitioner",
  GET_USERS_BY_PRACTITIONER = "GetUsersByPractitioner",
  GET_TECHNIQUES_AND_INTERVENTIONS = "GetTechniquesAndInterventions",
  GET_IN_APP_RESOURCES = "GetInAppResources",
  GET_CLIENT_DATA = "GetClientData",
  GET_SUPERVISORS_BY_ORG_ID = "GetSupervisorsByOrgId",
  GET_ORG_PRACTITIONER_COUNTS = "GetOrgPractitionerCounts",
}

export enum LogType {
  SIGN_IN = "sign in",
  SIGN_OUT = "sign out",
}

export enum SafetyPlanResponseOptionType {
  TEXT_BOX = "text_box",
  RADIO = "radio",
  CONTACT = "contact",
  USER_ADDED = "user_added",
  SELECT_ALL = "select_all",
  PLACE = "place",
}

export enum ClientDemoData {
  ALEX = "Alex is a 14-year-old male who recently presented with symptoms of depression, including feelings of sadness, hopelessness, guilt, and anhedonia. He has a PHQ-8 score of 14. He recently switched schools. He reports sleep difficulties include repeated awakenings in the middle of the night with difficulty falling back asleep. He has no prior history of mental health treatment and is not currently taking any medication. Alex’s stated goals are to “feel better and have more energy.”",
  SUSAN = "Susan is a 20 year-old female who originally presented with moderate anxiety and severe depressive symptoms. She was falling behind in classes and unable to work. She reports a history of suicidal thoughts but denies any attempts. She has shown recent reductions in anxiety and depressive symptoms, as evidenced by minimal-to-mild GAD-7 and moderate PHQ-8 score. She is generally adherent to weekly therapy and is improving her adherence to daily escitalopram.  Her stated goals are to “improve my mood”, “have less fatigue” and “keep up with my life and enjoy it more.”",
  JANICE = "Janice is a 44-year-old Asian American female who recently presented with symptoms of alcohol abuse and depression. She has an initial PHQ-8 score of 15 and a DAST-10 score of 9. She recently lost her job because of absenteeism and poor performance. Although she has used alcohol to a moderate to heavy level throughout her adult life, her difficulties have increased significantly after her divorce 18 months ago. She is not currently taking any medication. Janice’s stated goals are to “feel less depressed and to reduce her drinking.” Despite the fact that she wants to reduce her drinking she denies that it has had a significant negative effect on her life, and says that she “can get it under control”",
  LUCA = "Luca is a 22-year-old male who recently presented with symptoms of obsessive-compulsive disorder, especially checking and rituals. He has an OCI score of 44 and a GAD-7 score of 10. He has recently been missing work on some days because of an inability to leave the house in a timely fashion. He has obsessive cognitions about making a mistake that will cause a disaster, especially leaving the gas burners on at home. Even though he has extensive rituals associated with checking these burners before he leaves the house and goes to bed, he experiences severe anxiety about the possibility of leaving them on and causing an explosive fire. His rituals involve extensive checking of the burners, including repeating various checks multiple times. The rituals have been increasing in time over the last year and now take from 1-2 hours, depending on his level of anxiety. He reports mild symptoms of OCD since late childhood, but only recently have things escalated to the point where it has significantly interfered with role functioning, like attending work or social events. He is not currently taking any medication. Luca’s stated goals are to “feel less anxious, especially reducing his worries about causing a fire or explosion at home.”",
}

export const DBTDIARYCARDASSESSMENT_ID = "d4ec3d9b-599e-4384-ad5b-799a523e9263"

export const DBTDIARYCARDWEEKLYCHECKIN_ID =
  "65b9c8b1-949f-4ff1-8c4e-3db995801a24"

export const BRITE_SAFETY_PLAN = "Brite"
export const RELAPSE_PREVENTION_PLAN = "Relapse Prevention Plan"
